module.exports = __webpack_public_path__ + "img/treanorhouse-h-474x356.07c639de.jpg";